import React, { useState, useEffect } from 'react';
import {
  Divider,
  Card,
  CardHeader,
  Container,
  Grid,
  Tab,
  Box,
} from '@mui/material';
import axios from 'axios';
import { url } from 'src/Helpers/utils/Constant';
import { ITradeLicense } from 'src/Types/module/UpdateRequest/RequestTradeLicense';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import TradeLicenseIndex from './TradeLicenseIndex';
const RequestTradeLicenseInfo = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [tradeLicenseInfo, settradeLicenseInfo] = useState<ITradeLicense[]>([]);
  const [value, setValue] = React.useState('pending');

  useEffect(() => {
    setIsLoading(true);
    try {
      (async function () {
        const { data } = await axios.get(
          `${url}/api/atab/member-company/update-request/member/license?status=${value}`
        );

        if (data.success) {
          settradeLicenseInfo(data.data);
          setIsLoading(false);
        } else {
          setIsLoading(false);
        }
      })();
    } catch (error) {
      setIsLoading(false);
    }
  }, [value]);

  return (
    <Container sx={{ mt: 4 }} maxWidth='xl'>
      <Grid
        container
        direction='row'
        justifyContent='center'
        alignItems='stretch'
        spacing={3}
      >
        <Grid item xs={12}>
          <TabContext value={value}>
            <Card>
              <CardHeader
                title='Trade License information'
                action={
                  <Box sx={{ width: '100%' }}>
                    <Box sx={{ borderColor: 'divider' }}>
                      <TabList
                        onChange={(_event, newValue) => setValue(newValue)}
                        aria-label='lab API tabs example'
                      >
                        <Tab label='Pending' value='pending' />
                        <Tab label='Approved' value='approved' />
                        <Tab label='Rejected' value='rejected' />
                      </TabList>
                    </Box>
                  </Box>
                }
              />
              <Divider />
              <TabPanel value='pending'>
                <TradeLicenseIndex
                  isLoading={isLoading}
                  tradeLicenseInfo={tradeLicenseInfo}
                />
              </TabPanel>
              <TabPanel value='approved'>
                <TradeLicenseIndex
                  isLoading={isLoading}
                  tradeLicenseInfo={tradeLicenseInfo}
                />
              </TabPanel>
              <TabPanel value='rejected'>
                <TradeLicenseIndex
                  isLoading={isLoading}
                  tradeLicenseInfo={tradeLicenseInfo}
                />
              </TabPanel>
              {/* <Box p={2}>
              <TablePagination
                component='div'
                count={companyInfo?.length}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleLimitChange}
                page={page && page}
                rowsPerPage={limit}
                rowsPerPageOptions={[25, 50, 75, 100]}
              />
            </Box> */}
            </Card>
          </TabContext>
        </Grid>
      </Grid>
    </Container>
  );
};

export default RequestTradeLicenseInfo;
